module.exports = __webpack_public_path__ + "da128187f62e51b33b70e005fe497d.png";